<a
  *ngIf="validateAccessMenu(item) || nivel === 0"
  [ngClass]="[
    nivel === 0 ? 'dir-menu-govco' : '',
    nivel === 0 && !validateAccessMenu(item) ? 'oculto' : '',
    'nivel' + nivel
  ]"
  class="nav-link dir-menu-govco"
  [id]="'dropdown-menu-nav' + item.id"
  role="button"
  [attr.data-bs-toggle]="isMobile ? null : 'dropdown'"
  (click)="toggleDropdown(item.id)"
  aria-expanded="isDropdownOpen(item.id)"
  aria-current="page"
>
  <span class="container-text-icon-menu-govco">
    <span class="text-item-menu-govco">{{ item?.nombre }} </span>
    <span class="icon-caret-menu-govco"></span>
  </span>
</a>
<ul
  class="dropdown-menu"
  aria-labelledby="navbarDropdown"
  [id]="'dropdown-menu-' + item.id"
  [ngClass]="{'show': isDropdownOpen(item.id)}" 
>
  <li *ngFor="let itemChildren of item.children">
    <app-menu-item
      [item]="itemChildren"
      [itemParent]="item"
      [rolesUsuario]="rolesUsuario"
      [nivel]="nivel + 1"
      (cerrarMenu)="cerrarMenuEvt()"
    ></app-menu-item>
  </li>
</ul>
